// extracted by mini-css-extract-plugin
export var column = "columns-module--column--BI+TB";
export var columns = "columns-module--columns--V9+kw";
export var hideOnMobile = "columns-module--hideOnMobile--23oz7";
export var threeColumns = "columns-module--threeColumns--i7bUv";
export var twoColumns = "columns-module--twoColumns--rX-Xu";